import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui";
import { useCallback } from "react";
import { CountryDropdown } from "react-country-region-selector";
import { useFormContext, type UseFormRegisterReturn } from "react-hook-form";

interface CountrySelectFormFieldProps {
  register: UseFormRegisterReturn;
  label?: string;
  name: string;
  stateSelectName: string;
  dataTestId?: string;
}

export const CountrySelectFormField = ({
  register,
  label,
  name,
  stateSelectName,
  dataTestId,
}: CountrySelectFormFieldProps) => {
  const form = useFormContext();

  const customRender = useCallback(
    ({
      options,
    }: {
      options: { label: string; value: string; key: string }[];
    }) => {
      return (
        <FormField
          control={form.control}
          {...register}
          // @ts-expect-error This line is to remove a console error
          ref={null}
          render={({ field }) => (
            <FormItem>
              <div className="flex">
                <FormLabel>{label ?? "Country"}</FormLabel>
                <FormMessage
                  data-testid="error-message"
                  className="grow text-right"
                />
              </div>
              <Select
                data-testid={dataTestId}
                name={field.name}
                value={field.value ?? ""}
                onValueChange={(value) => {
                  form.setValue(name, value, {
                    shouldDirty: true,
                  });
                  form.setValue(stateSelectName, "", {
                    shouldDirty: true,
                  });
                }}
              >
                <FormControl>
                  <SelectTrigger>
                    <SelectValue
                      onBlur={field.onBlur}
                      ref={field.ref}
                      placeholder="Select a country"
                    />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {options
                    .filter((option) => option.value !== "")
                    .map(({ label, value, key }) => (
                      <SelectItem value={value} key={key}>
                        {label}
                      </SelectItem>
                    ))}
                </SelectContent>
              </Select>
            </FormItem>
          )}
        />
      );
    },
    [name, stateSelectName, label, form, register, dataTestId],
  );

  return (
    <CountryDropdown
      whitelist={["US", "MX", "CA"]}
      customRender={customRender}
    />
  );
};
